import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';

import BaseLayout from '../../layouts/BaseLayout';
import { Pagination } from '../../components';
import PostTeaser from '../../partials/blog/PostTeaser';

const Category = ({
  data: {
    allMarkdownRemark: { edges },
  },
  pageContext: {
    category,
    hasPrevPage,
    prevPageLink,
    hasNextPage,
    nextPageLink,
  },
}) => (
  <BaseLayout headerProps={{ contrast: false }}>
    <Helmet title={`Posts tagged with: ${category}`} />
    <div className="static-wrapper">
      <section className="section">
        <div className="container">
          <h1 className="u-textCenter u-textFluid--h3-h4 u-mb--xlarge">
            Posts tagged with {category}
          </h1>
          <ul className="blockGrid blockGrid-2@small blockGrid--largeGutter">
            {edges.map(({ node }) => (
              <li key={node.fileAbsolutePath}>
                <PostTeaser
                  title={node.frontmatter.title}
                  link={node.fields.fullUrl}
                  excerpt={node.excerpt}
                  featuredImage={node.fields.featuredImage}
                  author={node.frontmatter.author}
                  authorUrl={node.fields.authorUrl}
                />
              </li>
            ))}
          </ul>
          <Pagination
            hasPrevPage={hasPrevPage}
            hasNextPage={hasNextPage}
            prevPageLink={prevPageLink}
            nextPageLink={nextPageLink}
          />
        </div>
      </section>
    </div>
  </BaseLayout>
);

Category.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
};

export default Category;

export const pageQuery = graphql`
  query BlogCategory($category: String!, $skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      skip: $skip
      limit: $limit
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fileAbsolutePath: { regex: "/src/posts/" }
        frontmatter: { categories: { in: [$category] } }
      }
    ) {
      edges {
        node {
          ...PostTeaserFragment
        }
      }
    }
  }
`;
